<script>
export default {
  computed: {
    dinein() {
      return () => import(`@/components/Themes/${this.$cookies.get('theme') ?? 'default'}/Dinein`);
    }
  },
  methods: {},
};
</script>
<template>
  <component :is="dinein" v-on:open-drawer="$emit('open-drawer')" v-if="dinein"></component>
</template>